export default __webpack_public_path__ + "static/media/smartskin.3256f6c0.svg";